module.exports = __webpack_public_path__ + "friday.f6b9626145da9ae3ceb7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/friday.ttf?o83v8v
// module id = 1481
// module chunks = 0